// Foundations
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DateRange } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';

// rxjs
import { Observable, Subscription } from 'rxjs';

import { ReservationRequestItem } from 'src/app/models/reservation/reservation-request.model';

import * as lodash from 'lodash';

@Component({
  selector: 'app-reservation-date',
  templateUrl: './reservation-date.component.html',
  styleUrls: ['./reservation-date.component.scss'],
})
export class ReservationDateComponent implements OnInit, OnDestroy {
  // #region -> Property - Component IO <-
  // ----------

  @Input() useDateRange$: Observable<boolean>;
  useDateRange = false;
  useDateRangeSubscription: Subscription;

  @Output() selectedDateRange = new EventEmitter<DateRange<any>>();
  @Output() navigateToNext = new EventEmitter();

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Property <-
  // ----------

  form: FormGroup;

  firstSelectedDate: any;
  lastSelectedDate: any;
  dateRange: DateRange<any>;
  currentDate = new Date();

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Constructor <-
  // ----------

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this._initForm();
  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Lifecycle <-
  // ----------

  ngOnInit(): void {
    this.useDateRangeSubscription = this.useDateRange$.subscribe((useDateRangeFlag) => {
      this.useDateRange = useDateRangeFlag;
      //
      this.resetData();
    });
  }

  ngOnDestroy(): void {
    this.useDateRangeSubscription.unsubscribe();
  }


  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Method - UI <-
  // ----------

  onSelect(event): void {
    // if selected date is in the past show error
    if (this.currentDate > new Date(event)) {
      this.snackBar.open('Please select a date in the future', '', {
        duration: 2000,
      });
    } else {
      if (!this.useDateRange) {
        this.firstSelectedDate = event;
      } else {
        if (!this.firstSelectedDate && !this.lastSelectedDate) {
          this.firstSelectedDate = event;
        } else if (!this.lastSelectedDate) {
          this._calculateDateRange(event);
        } else {
          this.firstSelectedDate = event;
          this.lastSelectedDate = null;
        }
      }
      this.dateRange = new DateRange(
        this.firstSelectedDate,
        this.lastSelectedDate
      );
    }
  }

  isSaveEnabled(): boolean {
    //
    if (this.useDateRange && this.firstSelectedDate && this.lastSelectedDate) {
      return true;
    } else if (!this.useDateRange && this.firstSelectedDate) {
      return true;
    }
    return false;
  }

  onSave(): void {
    //
    this.selectedDateRange.emit(this.dateRange);
    // this.navigateToNext.emit();
  }

  resetData(reservationRequest?: ReservationRequestItem): void {
    if (reservationRequest) {
      this.dateRange = lodash.cloneDeep(reservationRequest.selectedDateRange);
      if (this.dateRange) {
        this.firstSelectedDate = this.dateRange.start;
        this.lastSelectedDate = this.dateRange.end;
      }
    } else {
      this.dateRange = null;
      this.firstSelectedDate = null;
      this.lastSelectedDate = null;
    }
  }

  // ----------
  // #endregion

  /////////////////////////////

  // #region -> Private Method <-
  // ----------

  private _initForm() {
    //
    this.form = this.fb.group({
      date: this.fb.array([]),
    });
  }

  private _calculateDateRange(event): void {
    if (new Date(this.firstSelectedDate) < new Date(event)) {
      this.lastSelectedDate = event;
    } else {
      this.firstSelectedDate = event;
    }
  }

  // ----------
  // #endregion

  /////////////////////////////
}
